import React, { useEffect } from 'react'
import Theme from '@/components/template/Theme'
import Layout from '@/components/layouts'
import { AuthProvider } from '@/auth'
import { useThemeStore } from '@/store/themeStore';
import PageContainer from '@/components/template/PageContainer';
import { NoteTabsProvider } from '@/contexts/NoteTabsContext';
import MasterPasswordSetupModal from '@/components/secrets/MasterPasswordSetupModal';
import MasterPasswordUnlockModal from '@/components/secrets/MasterPasswordUnlockModal';
import { useRouteKeySync } from '@/utils/hooks/useRouteKeySync';

// import '../locales'

function AppLayout({children, gutterless = false, footer = true}: { children: React.ReactNode, gutterless?: boolean, footer?: boolean }) {
  const { layout, setLayout } = useThemeStore((state) => state)
  useEffect(() => {
    if (layout.type !== 'collapsibleSide') {
      setLayout('collapsibleSide');
    }
  }, []);

  useRouteKeySync();

  return (
    <>
      <Theme>
        <AuthProvider>
          <NoteTabsProvider>
            <Layout>
              <PageContainer footer={footer} pageContainerType={gutterless ? 'gutterless' : 'default'}>
                {children}
              </PageContainer>
            </Layout>
            <MasterPasswordSetupModal />
            <MasterPasswordUnlockModal />
          </NoteTabsProvider>
        </AuthProvider>
      </Theme>
    </>
  )
}

export default AppLayout
